import { Badge } from "@/ui/ui/badge";
import { readAppBuildInfo, shouldShowBuildBadge } from "@/lib/buildInfo";

export const AppBuildBadge = () => {
  const buildInfo = readAppBuildInfo();

  if (!shouldShowBuildBadge(buildInfo.environment)) {
    return null;
  }

  return (
    <Badge variant="outline" className="border-sidebar-border/70 bg-sidebar-accent/20 text-sidebar-foreground/80">
      {buildInfo.environment} - {buildInfo.fullVersion}
    </Badge>
  );
};
